/**
 * Random id minted once per page load and never persisted, stamped on client
 * wide events (e.g. `rpc_usage`) as `tab_id` so a failure loop in one tab can
 * be told apart from many tabs of the same browser session (`sessionId`).
 */
let clientTabId: string | undefined

export function getClientTabId(): string | undefined {
  if (clientTabId) return clientTabId
  try {
    clientTabId = globalThis.crypto.randomUUID()
  } catch {
    return undefined
  }
  return clientTabId
}
